import React, { useState, useEffect, useCallback } from 'react';
import '../css/sg-platform.css';
import '../css/sg-pilars.css';
import Questionario from '../components/Questionario';
import {
  createCertification,
  getCertificationName,
  getRespostas,
} from '../services/fetch_api'; // Import the createCertification, getCertificationName, and getRespostas functions

const Pilares = () => {
  const [valuePilar, setValuePilar] = useState('');
  const [activePilar, setActivePilar] = useState(null);
  const [explorations, setExplorations] = useState([]);
  const [selectedExplorationCreate, setSelectedExplorationCreate] =
    useState('');
  const [selectedExplorationEdit, setSelectedExplorationEdit] = useState('');
  const [selectedCultureCreate, setSelectedCultureCreate] = useState('');
  const [selectedCultureEdit, setSelectedCultureEdit] = useState('');
  const [culturesCreate, setCulturesCreate] = useState([]);
  // const [certificadosEdit, setcertificadosEdit] = useState([]);
  const [hasCertifications, setHasCertifications] = useState(false);
  const [certificationId, setCertificationId] = useState(null);
  const [certificationNames, setCertificationNames] = useState([]);
  const [selectedCertificateId, setSelectedCertificateId] = useState(null);
  const [respostas, setRespostas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [questionarioKey, setQuestionarioKey] = useState(0);
  const [errorMessage, setErrorMessage] = useState(''); // Add state for error message

  // Map Pilar names to their respective IDs
  const pilarMapping = {
    Ambiental: 1,
    Social: 2,
    Económico: 3,
    Governança: 4,
  };

  useEffect(() => {
    const storedExplorations =
      JSON.parse(sessionStorage.getItem('exploracoes')) || [];
    setExplorations(storedExplorations);
    setHasCertifications(
      storedExplorations.some(
        (exploration) =>
          exploration.sg_certificados &&
          exploration.sg_certificados.length > 0 &&
          exploration.sg_certificados.some(
            (certificado) =>
              certificado.estado !== 'SUBMETIDO' &&
              certificado.estado !== 'CONCLUIDO'
          )
      )
    );

    // Check for URL parameters and auto-load questionnaire
    const urlParams = new URLSearchParams(window.location.search);
    const certificationIdFromUrl = urlParams.get('certification_id');
    const explorationIdFromUrl = urlParams.get('exploration_id');

    if (certificationIdFromUrl && explorationIdFromUrl) {
      // Auto-select the exploration and certificate
      const exploration = storedExplorations.find(
        (exp) => exp.id === parseInt(explorationIdFromUrl)
      );
      if (exploration) {
        setSelectedExplorationEdit(exploration);
        setSelectedCertificateId(certificationIdFromUrl);

        // Auto-load the responses and open questionnaire
        handleEditCertificationFromUrl(certificationIdFromUrl);
      }
    }
  }, []);

  // Add new function to handle automatic loading from URL
  const handleEditCertificationFromUrl = async (certId) => {
    try {
      setLoading(true);
      const response = await getRespostas(certId);
      setRespostas(response);
      setLoading(false);
      handlePilarClick('Ambiental'); // Auto-open with Ambiental pilar
    } catch (error) {
      console.error('Erro ao buscar respostas:', error);
      alert('Erro ao buscar respostas. Tente novamente.');
      setLoading(false);
    }
  };

  const handlePilarClick = async (pilarName) => {
    const pilarId = pilarMapping[pilarName]; // Get pilar_id from mapping
    setValuePilar(pilarId); // Update the selectedPilar state
    setActivePilar(activePilar === pilarName ? null : pilarName);
    setQuestionarioKey((prevKey) => prevKey + 1); // Force re-render of Questionario
    // console.log('Selected Pilar:', pilarName, 'with ID:', pilarId);
  };

  const handleExplorationChangeCreate = (event) => {
    const explorationId = event.target.value;
    setSelectedExplorationCreate(explorationId);
    const selectedExploration = explorations.find(
      (exploration) => exploration.id === parseInt(explorationId)
    );
    setCulturesCreate(selectedExploration ? selectedExploration.culturas : []);
  };

  const handleExplorationChangeEdit = (event) => {
    const explorationId = event.target.value;
    const selectedExploration = explorations.find(
      (exploration) => exploration.id === parseInt(explorationId)
    );
    setSelectedExplorationEdit(selectedExploration);
    // setcertificadosEdit(
    //   selectedExploration ? selectedExploration.sg_certificados : []
    // );
    setSelectedCertificateId(null); // Reset selected certificate ID
  };

  const handleCultureChangeEdit = (event) => {
    const cultureId = event.target.value;
    const selectedCulture = selectedExplorationEdit.culturas.find(
      (cultura) => cultura.id === parseInt(cultureId)
    );
    setSelectedCultureEdit(selectedCulture);
    // setcertificadosEdit(
    //   selectedExploration ? selectedExploration.sg_certificados : []
    // );
    // setSelectedCertificateId(null); // Reset selected certificate ID
  };

  const handleCultureChangeCreate = (event) => {
    setSelectedCultureCreate(event.target.value);
  };

  const handleCreateCertification = async () => {
    try {
      const response = await createCertification({
        exploracao_id: selectedExplorationCreate,
        cultura_id: selectedCultureCreate,
        data_creacao_certificacao: new Date().toISOString(),
      });
      setCertificationId(response.id); // Save the certification ID
      setQuestionarioKey((prevKey) => prevKey + 1); // Force re-render of Questionario
      // alert('Certificação criada com sucesso!');
      handlePilarClick('Ambiental'); // Call handlePilarClick after creating the certification
      setErrorMessage(''); // Clear error message on success
    } catch (error) {
      const message = error.response.data[0] || 'Erro ao criar certificação.';
      console.error('Erro ao criar certificação:', message);
      setErrorMessage(message); // Set error message
    }
  };

  const handleCertificateChangeEdit = (event) => {
    setSelectedCertificateId(event.target.value);
    handleCultureChangeEdit(event);
  };

  const handleEditCertification = async () => {
    if (!selectedCertificateId) return;

    try {
      setLoading(true);
      const response = await getRespostas(selectedCertificateId);
      setRespostas(response);
      setLoading(false);
      handlePilarClick('Ambiental');
    } catch (error) {
      console.error('Erro ao buscar respostas:', error);
      alert('Erro ao buscar respostas. Tente novamente.');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedExplorationEdit && selectedExplorationEdit.sg_certificados) {
      const fetchCertificationNames = async () => {
        const names = await Promise.all(
          selectedExplorationEdit.sg_certificados.map(async (certificado) => {
            try {
              const response = await getCertificationName(certificado.id);
              return response;
            } catch (error) {
              console.error('Error fetching certification name:', error);
              return 'Unknown Certification';
            }
          })
        );
        setCertificationNames(names);
      };

      fetchCertificationNames();
    }
  }, [selectedExplorationEdit]);

  const cultura_tipo = useCallback(() => {
    try {
      if (selectedExplorationEdit && selectedExplorationEdit.sg_certificados) {
        const selectedCertificate =
          selectedExplorationEdit.sg_certificados.find(
            (cert) => cert.id === Number(selectedCertificateId)
          );

        if (!selectedCertificate) return null;

        const cultura_id = selectedCertificate.cultura_id;
        const selectedCultura = selectedExplorationEdit.culturas.find(
          (cultura) => cultura.id === cultura_id
        );

        return selectedCultura?.indicador_adequado || null;
      } else if (selectedExplorationCreate) {
        const exploration = explorations.find(
          (exploration) => exploration.id === Number(selectedExplorationCreate) // Ensure IDs are numbers
        );

        if (!exploration) return null;

        const selectedCultura = exploration.culturas.find(
          (cultura) => cultura.id === Number(selectedCultureCreate) // Ensure IDs are numbers
        );

        // console.log(
        //   'cultura_tipo:',
        //   selectedCultura?.indicador_adequado || null
        // ); // Debugging line
        return selectedCultura?.indicador_adequado || null; // Handle missing properties
      }
    } catch (error) {
      console.error('Error in cultura_tipo:', error);
      return null; // Return null in case of an error
    }
  }, [
    selectedExplorationEdit,
    selectedCertificateId,
    selectedExplorationCreate,
    selectedCultureCreate,
    explorations,
  ]);

  useEffect(() => {
    if (valuePilar && selectedCertificateId) {
      const renderQuestionario = () => (
        <Questionario
          pilar_id={valuePilar}
          cultura_tipo={cultura_tipo()}
          certification_id={Number(selectedCertificateId)} // Pass certification_id only if selectedCertificateId is truthy
          respostas={respostas} // Pass respostas to Questionario component
        />
      );

      renderQuestionario();
    }
  }, [
    valuePilar,
    selectedCertificateId,
    respostas,
    selectedExplorationEdit,
    selectedCultureEdit,
    selectedExplorationCreate,
    questionarioKey,
    cultura_tipo,
  ]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const updatePilarState = (newPilarId) => {
    const pilarName = Object.keys(pilarMapping).find(
      (key) => pilarMapping[key] === newPilarId
    );
    if (pilarName) {
      setValuePilar(newPilarId);
      setActivePilar(pilarName);
      scrollToTop(); // Scroll to the top of the page
    }
  };

  return (
    <>
      <section className="certifications-container">
        <h1>Avaliações</h1>
        {/* --------------- Criação da Certificação --------------- */}
        <div className="create-certification">
          <div>
            <select
              className="exploration-selector"
              id="exploration"
              onChange={handleExplorationChangeCreate}
            >
              <option value="" disabled selected>
                Selecione uma Exploração
              </option>
              {explorations
                .filter(
                  (exploration) =>
                    exploration.culturas &&
                    exploration.culturas.length > 0 &&
                    (!exploration.sg_certificados ||
                      exploration.sg_certificados.length === 0)
                  /*exploration.sg_certificados.some(
                    (certificado) =>
                      certificado.estado !== 'PENDENTE' &&
                      certificado.estado !== 'SUBMETIDO' &&
                      certificado.estado !== 'CONCLUIDO'
                  ) */
                )
                .map((exploration) => (
                  <option key={exploration.id} value={exploration.id}>
                    {exploration.title}
                  </option>
                ))}
            </select>
          </div>

          {selectedExplorationCreate && (
            <div>
              <select
                className="culture-selector"
                id="culture"
                onChange={handleCultureChangeCreate}
              >
                <option value="" disabled selected>
                  Selecione uma Cultura
                </option>
                {culturesCreate.map((culture) => (
                  <option key={culture.id} value={culture.id}>
                    {culture.nome}
                  </option>
                ))}
              </select>
            </div>
          )}

          <a>
            <button
              className="btn-add"
              disabled={!selectedExplorationCreate || !selectedCultureCreate}
              onClick={() => handleCreateCertification()}
            >
              Criar Avaliação
              <i class="fa-solid fa-plus"></i>
            </button>
          </a>
        </div>
        {errorMessage && <p className="error-message">{errorMessage}</p>}{' '}
        {/* Display error message */}
        {/* --------------- Edição da Certificação --------------- */}
        {/* {console.log('certifications:', hasCertifications)} */}
        {hasCertifications && (
          <div className="edit-certification">
            <div>
              <select
                className="exploration-selector"
                id="exploration-edit"
                onChange={handleExplorationChangeEdit}
              >
                <option value="" disabled selected>
                  Selecione uma Exploração
                </option>
                {explorations
                  .filter(
                    (exploration) =>
                      exploration.sg_certificados &&
                      exploration.sg_certificados.length > 0 &&
                      exploration.sg_certificados.some(
                        (certificado) =>
                          certificado.estado === 'CRIADO' ||
                          certificado.estado === 'PENDENTE'
                      )
                  )
                  .map((exploration) => (
                    <option key={exploration.id} value={exploration.id}>
                      {exploration.title}
                    </option>
                  ))}
              </select>
            </div>

            {selectedExplorationEdit && (
              <div>
                {loading ? (
                  <p>Loading certifications...</p>
                ) : (
                  <select
                    className="exploration-selector"
                    id="certificate-edit"
                    onChange={handleCertificateChangeEdit}
                    value={selectedCertificateId || ''} // Add this line to maintain selection
                  >
                    <option value="" disabled selected>
                      Selecione uma Avaliação
                    </option>
                    {certificationNames
                      .filter(
                        (_, index) =>
                          selectedExplorationEdit.sg_certificados[index]
                            .estado !== 'SUBMETIDO' &&
                          selectedExplorationEdit.sg_certificados[index]
                            .estado !== 'PROCESSADO' &&
                          selectedExplorationEdit.sg_certificados[index]
                            .estado !== 'VALIDADO' &&
                          selectedExplorationEdit.sg_certificados[index]
                            .estado !== 'CONCLUIDO'
                      )
                      .map((name, index) => (
                        <option
                          key={index}
                          value={
                            selectedExplorationEdit.sg_certificados[index].id
                          }
                        >
                          {name.display_name}
                        </option>
                      ))}
                  </select>
                )}
                {/* Show the culture name for the selected certificate */}
                {/* {selectedCertificateId &&
                  selectedExplorationEdit &&
                  (() => {
                    const cert = selectedExplorationEdit.sg_certificados.find(
                      (c) => c.id === Number(selectedCertificateId)
                    );
                    const cultura =
                      cert &&
                      selectedExplorationEdit.culturas.find(
                        (cu) => cu.id === cert.cultura_id
                      );
                    return cultura ? (
                      <div className="culture-info">
                        <label>Cultura:</label>
                        <span>{cultura.nome}</span>
                      </div>
                    ) : null;
                  })()} */}
              </div>
            )}
            <a>
              <button
                className="btn-save-edit"
                onClick={handleEditCertification}
              >
                Editar Avaliação <i class="fa-solid fa-pencil"></i>
              </button>
            </a>
          </div>
        )}
      </section>

      {/* --------------- Pilares --------------- */}
      <section className="pilares-container">
        <div className="pilares">
          {Object.keys(pilarMapping).map((pilarName) => (
            <button
              key={pilarMapping[pilarName]}
              className={`btn-pilar ${
                activePilar === pilarName ? 'active' : ''
              }`}
              onClick={() => handlePilarClick(pilarName)}
              disabled={!certificationId && !selectedCertificateId}
              title={
                !certificationId && !selectedCertificateId
                  ? 'Por favor, selecione ou crie uma certificação primeiro'
                  : ''
              }
            >
              <h3>{pilarName}</h3>
            </button>
          ))}
        </div>
      </section>
      {valuePilar && (
        <Questionario
          key={questionarioKey} // Use key to force re-render
          pilar_id={valuePilar}
          certification_id={
            selectedCertificateId
              ? Number(selectedCertificateId)
              : Number(certificationId)
          }
          cultura_tipo={cultura_tipo()}
          respostas={respostas} // Pass respostas to Questionario component
          updatePilarState={updatePilarState} // Pass the updatePilarState function
        />
      )}
    </>
  );
};

export default Pilares;
